import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { formatDecimal } from "../../utils/numberFormat";

// Colors follow the existing Analytics chart convention (blue family, e.g.
// BookingsByDayChart.jsx's #2563EB) rather than the brand pink, for
// consistency with the rest of the app's chart visuals.
function UsageOverTimeChart({ data }) {
  if (!data?.length) {
    return <div style={{ padding: 32, textAlign: "center", color: "#9CA3AF", fontSize: 14 }}>No data available</div>;
  }
  // qty_consumed/cost_consumed arrive as raw DECIMAL strings from the API -
  // coerce to numbers so recharts computes bar heights correctly, not just
  // for tooltip display.
  const chartData = data.map((d) => ({ ...d, qty_consumed: Number(d.qty_consumed), cost_consumed: Number(d.cost_consumed) }));
  return (
    <ResponsiveContainer width="100%" height={240}>
      <BarChart data={chartData} barSize={18}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" vertical={false} />
        <XAxis dataKey="period" tick={{ fill: "#6B7280", fontSize: 12 }} axisLine={false} tickLine={false} />
        <YAxis tick={{ fill: "#6B7280", fontSize: 12 }} axisLine={false} tickLine={false} />
        <Tooltip
          contentStyle={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 8, fontSize: 12 }}
          formatter={(value) => formatDecimal(value)}
        />
        <Bar dataKey="qty_consumed" name="Qty consumed" fill="#2563EB" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}

export default UsageOverTimeChart;
